import 'jquery-migrate';
import $ from 'jquery';
import UfaCaller from '../ufa/UfaCaller';
import { ufa } from '@uberflip/ufa-client';
import Privacy from './privacy';
import {augmentJquery} from './legacyCodePollyfills/legacyCodePollyfills';

// Expose ufa global on stream login page
window.ufa = ufa;
window.Hubs = {};
window.$ = window.jQuery = $;

// Augment jQuery with functionality previously supplied by:
// -- jquery.cookie
// -- jquery.fitvids
// -- jquery.perfectScrollbar
// For backawards compatibility with custom code
augmentJquery.withAllPollyfills($);

require('./constants.js');
require('./privacy_helpers.js');

/**
 * Remove any current error messages, and display the new error message
 *
 * @param {string} msg
 * @param {jsonObject} authLabels
 */
const handleError = (msg, authLabels) => {

  $('.uf-steam-login-error').remove();
  const $errorNotifier = `
    <div class="uf-steam-login-error">
      <p role="alert"><strong>${authLabels.failure} </strong>${msg}</p>
    </div>
  `;

  $('body').append($errorNotifier);
};

/**
 * Return one of the two possible error types from the server response,
 * if we get some other error undefined will be returned, causing
 * handleError to fall back on its default error message
 *
 * @param {object} response
 * @returns {string | undefined}
 */
const getErrorMessage = (response) => {
  try {
    if (response.meta.error.message) {
      return response.meta.error.message[0];
    }

    if (response.meta.error.generic) {
      return response.meta.error.generic[0];
    }
  } catch(err) {
    return 'Something went wrong';
  }
};

/**
 * Currying function that returns a new submit handling funciton with appropriate
 * streamID/baseURL included for when the login form is submitted.
 *
 * @param {pageConfig} param0 - Object containing the stream ID and hub base URL
 */
const handlePassphraseSubmit = ({ hubBaseUrl, streamId, authLabels }) => function (e) {
  e.preventDefault();
  const $streamLoginContainer = $('.uf-stream-login');
  const $submitButton = $(this).find('.uf-stream-login-form-submit');
  const $fields = $(this).find('.uf-stream-login-form-fields');
  const joiningCharacter = hubBaseUrl.endsWith('/') ? '' : '/';
  const url = `${hubBaseUrl}${joiningCharacter}hubsFront/ajax_authenticate/passphrase`;
  const originalButtonText = $submitButton.text();

  $streamLoginContainer.addClass('authenticating');
  $submitButton.html(authLabels.authenticating);

  $fields.prop('disabled', true);

  $.ajax({
    url,
    method: 'POST',
    data: {
      passphrase: this.passphrase.value,
      streamId
    }
  })
    .done(() => {
      $submitButton.text(authLabels.redirect);
      window.location.reload();
    })
    .fail(({ responseJSON }) => {
      handleError(getErrorMessage(responseJSON), authLabels);
      $streamLoginContainer.removeClass('authenticating');
      $submitButton.text(originalButtonText);
      $fields.prop('disabled', false);
    });
};

/**
 * Initialization function for the page, called in the .thtml file
 *
 * @param {object} pageConfig
 */
const init = (pageConfig) => {
  $(() => {
    $('.uf-stream-login-form').on('submit', handlePassphraseSubmit(pageConfig));
  });

  const ufaCaller = new UfaCaller({
    ufaUrl: pageConfig.serverUrl.ufa,
    accountId: pageConfig.accountId,
    hubId: pageConfig.hubId,
    pageType: pageConfig.pageType,
    pardotCookie: pageConfig.pardotCookie,
    connectedMAPs: pageConfig.mapIntegrations,
    streamId: pageConfig.streamId || null,
    itemId: pageConfig.itemId || null,
    authorId: pageConfig.authorId || null,
    requireOptIn: UfaCaller.ufaRequiresOptIn(pageConfig)
  });

  if (!pageConfig.isPreventAnalyticsCollectionEnabled) {
    ufaCaller
        .init()
        .trackPageView()
        .trackVisitorData();
  }

  window.Hubs = Object.assign(window.Hubs, {
    Config: pageConfig,
    Privacy: Privacy,
    appInstance: Object.assign({ ufaCaller }, Hubs.PrivacyHelpers),
    Events: {
      on: $.fn.on.bind($(window)) // Allow 'load', 'resize', 'scroll', and method chaining, to still work as expected.
    }
  });
};

export { init };
